import { Suspense } from 'react';

import { useSuspenseQuery } from '@tanstack/react-query';

import { Chip, Skeleton } from '@mui/material';

import { useFieldContext } from '#form';

import { industryQueries } from '@repo/api/shared/industry';
import { CodeInput } from '@repo/ui/CodeInput';
import { LabelInput } from '@repo/ui/LabelInput';

export function IndustryInput({
	uk,
	subLabel,
}: {
	uk?: boolean;
	subLabel?: string;
}) {
	const field = useFieldContext<number | null | undefined>();

	const label = uk ? 'Industry Code' : 'NAICS Code';

	return (
		<Suspense
			fallback={
				<LabelInput label={label} fieldName={field.name} subLabel={subLabel}>
					<Skeleton
						sx={{
							height: 40,
							transform: 'none',
						}}
					/>
				</LabelInput>
			}
		>
			<IndustrySelector uk={uk} label={label} subLabel={subLabel} />
		</Suspense>
	);
}

function IndustrySelector({
	uk,
	label,
	subLabel,
}: {
	uk?: boolean;
	label: string;
	subLabel?: string;
}) {
	const field = useFieldContext<number | null | undefined>();

	const query = uk ? industryQueries.uk() : industryQueries.naics();
	const { data: naics } = useSuspenseQuery(query);

	return (
		<CodeInput
			label={label}
			name={field.name}
			value={field.state.value}
			onChange={field.handleChange}
			errors={field.state.meta.errors}
			codes={naics}
			subLabel={subLabel}
			renderCode={(code) => (
				<Chip
					size="small"
					label={code}
					sx={{ fontVariantNumeric: 'tabular-nums' }}
				/>
			)}
		/>
	);
}
